import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import fr from 'facet-rest';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import Sidebar from 'Views/Page/Content/Templates/WhatIfTemplate/Components/Sidebar';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';

const styles = () => ({
  root: {
    height: '100%',
  },
  sidebar: {
    height: '100%',
  },
});

const SidebarContent = ({
  className,
  classes,
}) => {
  const { pageContentResource, loadPageContentLink } = usePageContentContext();

  const handleTabChange = tabKey => {
    const [activeTabResource] = pageContentResource.attr('sidebarTabs').resources().list().filter((tabResource) => {
      return tabResource.attr('key') === tabKey;
    });
    loadPageContentLink(activeTabResource?.relationship(fr.relationships.tabData.name).link('related'));
  };

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <Sidebar
        className={classes.sidebar}
        onChange={handleTabChange}
      />
    </Box>
  );
};

SidebarContent.defaultProps = {
  className: '',
};

SidebarContent.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SidebarContent);
